// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.csi-middleware-customView-CustomViewDialogHeader-module-favoriteButton {
	margin-left: 4px;
	margin-right: 4px;
}`, "",{"version":3,"sources":["webpack://./src/csi/middleware/customView/CustomViewDialogHeader.module.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,iBAAiB;AAClB","sourcesContent":[".favoriteButton {\n\tmargin-left: 4px;\n\tmargin-right: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"favoriteButton": `csi-middleware-customView-CustomViewDialogHeader-module-favoriteButton`
};
module.exports = ___CSS_LOADER_EXPORT___;
